import useTranslation from "../../../hooks/i18n/useTranslation";
import {
  getTargetTypeDisplayLabel,
  TargetTypeEnum,
} from "../../../classes/enums/SppEnum";
import Tooltip, {
  TooltipOrientation,
} from "../../../components/tooltip/Tooltip";
import "./OctTab.css";

const OctTab = ({
  isAlign = false,
  targetType = TargetTypeEnum.GAP,
  compareMode = false,
  currentPlanLabel = "Plan",
  comparedPlanLabel = "Plan",
}) => {
  const { t } = useTranslation();
  const target = getTargetTypeDisplayLabel(targetType);
  const currentLabel = currentPlanLabel?.toUpperCase();
  const comparedLabel = comparedPlanLabel?.toUpperCase();

  return (
    <div className="OctTab-container">
      {isAlign &&
        (compareMode ? (
          <>
            <div className="OctTab-title blue App-text-medium">
              {currentLabel}
            </div>
            <div className="OctTab-title blue App-text-medium">
              {comparedLabel}
            </div>
          </>
        ) : (
          <>
            <Tooltip text={t("423")} orientation={TooltipOrientation.Top}>
              <div className="OctTab-title green App-text-medium">{target}</div>
            </Tooltip>
            <Tooltip text={t("422")} orientation={TooltipOrientation.Top}>
              <div className="OctTab-title blue App-text-medium">{"PLAN"}</div>
            </Tooltip>
          </>
        ))}
      <Tooltip text={t("421")} orientation={TooltipOrientation.Top}>
        <div className="OctTab-title red App-text-medium">{"PRE"}</div>
      </Tooltip>
    </div>
  );
};

export default OctTab;
